/* eslint-disable*/
export const TOP_CARD_NAMES = {
    TOTAL_AVAILABLE_SHIPMENTS: "Total Available",
    INBOUND_PENDENCY: "Inbound Pendency",
    OUTSCAN_PENDING_INSCAN_TO_HUB: "Outscan Pending Inscan To Hub",
    OUTSCAN_PENDING_INSCAN_TO_CP: "Outscan Pending Inscan To Cp",
};
